import React from 'react';
import classNames from 'classnames';

// No guest-count badge — GetrestableOrderNum doesn't carry a guest count
// (see API_MAPPING.md), so there's nothing real to show in it right now.
function TableTile({ table, selected, onClick }) {
    return (
        <div
            className={classNames(
                'captain-table',
                `captain-table--${table.shape}`,
                `captain-table--${table.status}`,
                { 'captain-table--selected': selected }
            )}
            onClick={() => onClick(table)}
        >
            <span className="captain-table-number">{table.id}</span>
        </div>
    );
}

export default TableTile;
